/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import ListItemLink from '../../../../../../components/Common/ListItemLink/ListItemLink';
import PaymentForm from '../../../../../../components/Payments/PaymentForm';
import TransferFundsForm from '../../../../../../components/UserFlowFunds/TransferFundsForm';
import ActivatedCouponForm from '../../../../../../components/Payments/ActivatedCouponForm';

class MyBalancePay extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="panel panel-default panel-heading_padding-large panel-user-balance">
          <div className="panel-heading">
            <h1 className="panel-title text-center">
              <i className="fa fa-rub" aria-hidden="true" />{' '}
              {t('Пополнить <strong>баланс</strong>')}
            </h1>
          </div>
          <div className="panel-bar">
            <ul className="nav nav-tabs nav-tabs-lg">
              <ListItemLink to={'/main/my-balance/pay/payment'}>
                {t('Пополнить счет')}
              </ListItemLink>
              <ListItemLink to={'/main/my-balance/pay/transfer-funds'}>
                {t('Перевести с основного счета')}
              </ListItemLink>
              <ListItemLink to={'/main/my-balance/pay/activated-coupon'}>
                {t('Активировать купон')}
              </ListItemLink>
            </ul>
          </div>

          <div className="panel-body">
            <div className="tab-content">
              <div className="tab-pane active">
                <Switch>
                  <Route
                    exact
                    path="/main/my-balance/pay"
                    render={() => (
                      <Redirect from="/" to="/main/my-balance/pay/payment" />
                    )}
                  />
                  <Route
                    path="/main/my-balance/pay/payment"
                    render={() => <PaymentForm />}
                  />
                  <Route
                    path="/main/my-balance/pay/transfer-funds"
                    render={() => <TransferFundsForm />}
                  />
                  <Route
                    path="/main/my-balance/pay/activated-coupon"
                    render={() => <ActivatedCouponForm />}
                  />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(MyBalancePay);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyBalance/MyBalancePay/MyBalancePay.js